import { SizeBreakpoint, styled } from '@openeducation/oe-rn-themes';

import { OpenEnglishLogo } from '../../atoms';
import { TopMenu, TopMenuItem } from '../top-menu/top-menu';

export interface PageHeaderProps {
  pages: TopMenuItem[];
}

export function PageHeader({ pages }: PageHeaderProps) {
  return (
    <Container>
      <Content>
        <OpenEnglishLogo />

        <MenuDivider />

        <TopMenu items={pages} />
      </Content>
    </Container>
  );
}

const Container = styled.View`
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.color.background};
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.border};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
`;

const Content = styled.View`
  width: 100%;
  max-width: ${SizeBreakpoint.XL}px;

  flex-direction: row;
  align-items: center;
`;

const MenuDivider = styled.View`
  margin-right: 16px;
  margin-left: 24px;
  width: 1px;
  height: 24px;
  background-color: ${({ theme }) => theme.color.border};
`;
